import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  value: boolean;
  className?: string;
};
const ActiveStatusCell = ({ value, className }: Props) => {
  const { t } = useTranslation('common');
  return <div className={className}>{value ? t('yes') : t('no')}</div>;
};

export default ActiveStatusCell;
